import React from "react";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink, DisabledButton } from "../components/ButtonLink";
import {
  Breadcrumbs,
  Card,
  FeatureGrid,
  PageHero,
  PolicyAlert,
  SectionHeading,
} from "../components/RedlandComponents";

export default function JuniorCamp() {
  const { juniorCamp, contact } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="Junior Camp" />
      <PageHero
        eyebrow="Junior Program"
        title={juniorCamp.title}
        copy={juniorCamp.mission}
        image={juniorCamp.heroImage}
        badge="Ages 5-16"
        tags={["Golf instruction", "Core values", "Healthy habits", "Games and sports"]}
        metaTitle="2026 Program"
        metaItems={["June 8-July 31", "Monday-Thursday, 9 AM-3 PM", "$250 per week"]}
        actions={<ButtonLink href={contact.emailHref}>Email Completed Forms</ButtonLink>}
      />
      <section className="section">
        <div className="container">
          <SectionHeading title="Program Details" />
          <div className="detail-grid">
            {juniorCamp.details.map((detail, i) => (
              <Card key={detail.label || i}>
                <p className="eyebrow">{detail.label}</p>
                <h3>{detail.value}</h3>
              </Card>
            ))}
          </div>
        </div>
      </section>
      <section className="section section-cream">
        <div className="container">
          <SectionHeading title="Camp Components" />
          <FeatureGrid items={juniorCamp.components} />
        </div>
      </section>
      <section className="section">
        <div className="container">
          <SectionHeading title="Core Values" />
          <FeatureGrid items={juniorCamp.coreValues} />
        </div>
      </section>
      <section className="section section-cream">
        <div className="container">
          <PolicyAlert title="Sign Up Now">
            <p>
              To register, please complete the participation permission form and registration form,
              then email the completed forms to{" "}
              <a href={contact.emailHref}>redlandgolfcc@aol.com</a>.
            </p>
            <div className="inline-actions">
              {juniorCamp.forms.map((form) =>
                form.href ? (
                  <ButtonLink href={form.href} key={form.label} variant="secondary">
                    {form.label}
                  </ButtonLink>
                ) : (
                  <DisabledButton key={form.label}>{form.label}: Coming Soon</DisabledButton>
                )
              )}
              <ButtonLink href={contact.emailHref}>Email Completed Forms</ButtonLink>
            </div>
          </PolicyAlert>
        </div>
      </section>
      <section className="section">
        <div className="container card-grid two">
          <Card>
            <h2>Contact Information</h2>
            <p>{juniorCamp.contactName}</p>
            <p>
              <a href={contact.phoneHref}>305-247-8503, extension 3</a>
            </p>
            <p>
              <a href={contact.timTronzoMobileHref}>{contact.timTronzoMobileDisplay}</a>
            </p>
          </Card>
        </div>
      </section>
    </>
  );
}
